enum MultiSelectModalConfig {
  ConfirmButtonTitle = "Save changes",
  DiscardChangesAlertMessage = "Are you sure you want to discard changes?",
  DiscardChangesAlertTitle = "Discard changes?",
  DiscardChangesButtonTitle = "Discard",
  DismissButtonAccessibilityLabel = "Dismiss MultiSelect Modal",
  SearchPlaceholder = "Search",
}

export default MultiSelectModalConfig;
